import styled from "@emotion/styled";
import { colors } from "goi_common";
import { useState } from "react";
import SlideBase from "react-slick";
import { Box } from "@chakra-ui/react";

export default function GuideSlider() {
  const initialSlide = 0;
  const [, setBeforeCount] = useState(initialSlide);

  return (
    <Slide
      initialSlide={initialSlide}
      beforeChange={(_, next) => setBeforeCount(next)}
      arrows={false}
      autoplay={true}
      autoplaySpeed={5000}
      className="body_14_m gray700"
    >
      <Box background={colors.gray50} padding="12px 24px" borderRadius="10px">
        <div>
          장례에 온전히 집중할 수 있는 <br /> 장례지도사를 추천드려요.
        </div>
      </Box>

      <Box background={colors.gray50} padding="12px 24px" borderRadius="10px">
        <div>
          전화상담은 장례준비의 핵심이에요 <br />
          24시간 상담이 가능하니 부담없이 연락하세요
        </div>
      </Box>
    </Slide>
  );
}

const Slide = styled(SlideBase)`
  .slick-arrow {
    display: none;
  }
  .slick-slide {
    padding: 0 24px;
  }
`;
